import { ComplexRoute } from 'router/components/Routes/Routes';
import VacancyBeforePublishPreview from '../../../../pages/VacancyBeforePublishPreview';
import VacancyWizard from '../../../../../../pages/VacancyWizard';

export default [
  {
    path: ':stepName',
    element: VacancyWizard,
    validate: ({ createVacancyWizard }, { stepName }) => {
      const { currentStepIndex, steps } = createVacancyWizard;
      const index = steps.findIndex((s) => s === stepName);
      return index > currentStepIndex ? `../${steps[0]}` : '';
    },
  },
  {
    path: 'preview',
    element: VacancyBeforePublishPreview,
  },
  {
    index: true,
    element: VacancyWizard,
    validate: ({ createVacancyWizard }) => {
      const { steps, currentStepIndex } = createVacancyWizard;
      return `${steps[currentStepIndex]}`;
    },
  },
] as Array<ComplexRoute>;
